module.exports = __webpack_public_path__ + "img/1-1.5f73d423.png";